import React, {Fragment} from 'react';
import ELDataForm from "./DataForm";
import ELCategoryTree from "./CategoryTree";
import ELDataSelect from "./DataSelect";
import {EL_MODE_CREATE} from "../constants";

const ELDataStep = ({mode}) => mode === EL_MODE_CREATE
  ? (
    <Fragment>
      <div style={{marginBottom: 16}}>
        <ELDataForm/>
      </div>
      <ELCategoryTree/>
    </Fragment>
  )
  : (
    <ELDataSelect/>
  );

export default ELDataStep;



// WEBPACK FOOTER //
// ./src/components/easy-loading/data-step/index.jsx